function registerInfiniteScrollLoadMoreButton() {
  const selectors = {
    loadMoreButton: ".js-load-more",
    totalPages: "[data-total-pages]",
    currentPage: "[data-current-page]",
    nextUrl: "[data-next-url]",
    loadMoreText: "[load-more-text]",
    loaderText: "[loader-text]",
    products: ".collection__products .grid-item.product-item:not(.product-grid-item-placeholder)",
    productGrid: "div[data-products-grid] .grid",
    currentProducts: ".current-products",
    totalProducts: ".total-products",
  };

  const hideClass = "hide";
  const loadMoreButton = document.querySelector(selectors.loadMoreButton);
  const loadMoreContainer = document.querySelector(".LoadMore--container");
  const currentItemCount = loadMoreContainer?.querySelector(".current-item-count");

  if (loadMoreButton == null) {
    return;
  }

  loadMoreButton.addEventListener("click", (e) => {
    const totalPagesValue = Number(document.querySelector(selectors.totalPages).value);
    let currentPage = document.querySelector(selectors.currentPage);
    let currentPageValue = parseInt(currentPage.value);
    let nextUrl = document.querySelector(selectors.nextUrl);
    let pageSize = document.querySelector("[data-total-page-size]");
    let pageSizeValue = pageSize ? parseInt(pageSize.value) : 0;

    // Remove cursor param from nextUrl if present (new logic)
    let nextUrlValue = nextUrl ? nextUrl.value : null;
    if (nextUrlValue) {
      const urlObj = new URL(nextUrlValue, window.location.origin);
      urlObj.searchParams.delete('cursor');
      nextUrlValue = urlObj.pathname + urlObj.search;
    }

    loadMoreButton.setAttribute("disabled", true);
    loadMoreButton.classList.remove("button--primary");
    loadMoreButton.classList.add("button--secondary");

    const loadMoreText = loadMoreButton.querySelector(selectors.loadMoreText);
    const loaderText = loadMoreButton.querySelector(selectors.loaderText);

    loadMoreText.classList.add(hideClass);
    loaderText.classList.remove(hideClass);

    fetch(nextUrlValue)
      .then((response) => response.text())
      .then((html) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        // Product/Blog logic (from Untitled-3)
        if (
          window.location.href.includes("collections") ||
          window.location.href.includes("search")
        ) {
          const products = doc.querySelectorAll(".product-grid > .grid__item:not(.breaker_item)");
          const productList = document.querySelector(".product-grid");

          var isSafari = window.safari !== undefined;

          if (products) {
            products.forEach((product) => {
              if (isSafari) {
                const images = product.querySelectorAll(".card__media img");
                images.forEach((_) => {
                  _.removeAttribute("srcset");
                });
              }
              productList.append(product);

              // Start any video that is in the product
              const video = product.querySelector("video");
              if (video) {
                video.play();
              }
            });
          }
        } else if (window.location.href.includes("blogs")) {
          const articles = doc.querySelectorAll(
            ".blog-articles > .blog-articles__article"
          );
          const allArticles = document.querySelectorAll(
            ".blog-articles__article"
          );
          const lastArticle = allArticles[allArticles.length - 1];

          articles?.forEach((article) => {
            lastArticle.appendChild(article);
          });
        }

        // Update current page and nextUrl (new logic)
        currentPage.value = currentPageValue + 1;

        const docNextUrl = doc.querySelector(selectors.nextUrl);
        if (docNextUrl && docNextUrl.value) {
          nextUrl.value = docNextUrl.value;
        } else {
          nextUrl.value = nextUrl.value.replace(
            `page=${currentPageValue + 1}`,
            `page=${currentPageValue + 2}`
          );
        }

        // Update item count if present
        if (currentItemCount && pageSizeValue) {
          currentItemCount.innerHTML = String(
            (currentPageValue + 1) * pageSizeValue
          );
        }

        // Hide button if last page, update product counts (new logic)
        if (currentPage.value >= totalPagesValue) {
          loadMoreButton.classList.add(hideClass);
          const currentProducts = document.querySelector(selectors.currentProducts);
          const totalProducts = document.querySelector(selectors.totalProducts);
          if (currentProducts && totalProducts) {
            currentProducts.innerHTML = totalProducts.innerHTML;
          }
          if (loadMoreContainer) {
            loadMoreContainer.remove();
          }
        } else {
          loadMoreButton.removeAttribute("disabled");
          loadMoreButton.classList.add("button--primary");
          loadMoreButton.classList.remove("button--secondary");
          loadMoreText.classList.remove(hideClass);
          loaderText.classList.add(hideClass);
        }

        // Update browser history (new logic)
        window.history.pushState(
          {
            param: Shopify.queryParams,
          },
          document.title,
          nextUrlValue
        );

        // Call any additional initialization
        if (typeof initializeQuickAdd === "function") {
          initializeQuickAdd();
        }
      })
      .catch((error) => {
        console.warn("Loading more failed", error);
        if (loadMoreContainer) {
          loadMoreContainer.remove();
        }
      });
  });
}

registerInfiniteScrollLoadMoreButton();
